'use client';
import { LegalShell, LegalSection, useLang, type Lang } from '@/components/LegalShell';

const C: Record<Lang, { title: string; sub: string; updated: string; s: { h: string; p: string[] }[] }> = {
  uk: {
    title: 'Повернення коштів', updated: '18.07.2026',
    sub: 'Умови повернення для цифрових товарів і послуг.',
    s: [
      { h: 'Загальний принцип', p: ['Цифрові товари (ключі, коди, доступи) вважаються використаними в момент передачі покупцю. Тому після успішної доставки повернення коштів, як правило, не здійснюється.'] },
      { h: 'Коли повернення можливе', p: ['Товар не був переданий покупцю у визначений строк; товар не працює/недійсний із вини Продавця й проблему не вдалося вирішити заміною. У таких випадках ми повертаємо кошти або надаємо робочий аналог.'] },
      { h: 'Як подати запит', p: ['Зверніться в підтримку на сторінці «Контакти», вкажіть номер замовлення й опишіть проблему. Ми розглянемо звернення протягом 1–3 робочих днів.'] },
      { h: 'Спосіб повернення', p: ['Кошти повертаються тим самим способом, яким було здійснено оплату. Строк зарахування залежить від платіжного оператора.'] },
    ],
  },
  ru: {
    title: 'Возврат средств', updated: '18.07.2026',
    sub: 'Условия возврата для цифровых товаров и услуг.',
    s: [
      { h: 'Общий принцип', p: ['Цифровые товары (ключи, коды, доступы) считаются использованными в момент передачи покупателю. Поэтому после успешной доставки возврат средств, как правило, не осуществляется.'] },
      { h: 'Когда возврат возможен', p: ['Товар не был передан покупателю в установленный срок; товар не работает/недействителен по вине Продавца и проблему не удалось решить заменой. В таких случаях мы возвращаем средства или предоставляем рабочий аналог.'] },
      { h: 'Как подать запрос', p: ['Обратитесь в поддержку на странице «Контакты», укажите номер заказа и опишите проблему. Мы рассмотрим обращение в течение 1–3 рабочих дней.'] },
      { h: 'Способ возврата', p: ['Средства возвращаются тем же способом, которым была произведена оплата. Срок зачисления зависит от платёжного оператора.'] },
    ],
  },
  en: {
    title: 'Refunds', updated: '2026-07-18',
    sub: 'Refund terms for digital goods and services.',
    s: [
      { h: 'General principle', p: ['Digital goods (keys, codes, access) are considered used upon transfer to the buyer. Therefore, after successful delivery, refunds are generally not provided.'] },
      { h: 'When a refund is possible', p: ['The goods were not delivered within the set time; the goods do not work / are invalid through the Seller’s fault and the issue could not be resolved by replacement. In such cases we refund the payment or provide a working alternative.'] },
      { h: 'How to request', p: ['Contact support on the “Contacts” page, provide your order number and describe the issue. We review requests within 1–3 business days.'] },
      { h: 'Refund method', p: ['Funds are returned via the same method used for payment. Crediting time depends on the payment operator.'] },
    ],
  },
};

export default function RefundPage() {
  const lang = useLang();
  const c = C[lang];
  return (
    <LegalShell title={c.title} subtitle={c.sub} updated={c.updated}>
      {c.s.map(sec => (
        <LegalSection key={sec.h} heading={sec.h}>
          {sec.p.map((t, i) => <p key={i} style={{ margin: i ? '10px 0 0' : 0 }}>{t}</p>)}
        </LegalSection>
      ))}
    </LegalShell>
  );
}
